// extracted by mini-css-extract-plugin
export var backgroundImage = "SkillsOverviewCardLeft-module--backgroundImage--4492e";
export var content = "SkillsOverviewCardLeft-module--content--aeb85";
export var contentWrapper = "SkillsOverviewCardLeft-module--contentWrapper--43cba";
export var list = "SkillsOverviewCardLeft-module--list--e501c";
export var mainTitle = "SkillsOverviewCardLeft-module--mainTitle--c2645";
export var mainTitleContainer = "SkillsOverviewCardLeft-module--mainTitleContainer--c7e80";
export var subTitle = "SkillsOverviewCardLeft-module--subTitle--a19e2";
export var textContent = "SkillsOverviewCardLeft-module--textContent--d5260";
export var title = "SkillsOverviewCardLeft-module--title--25530";
export var wrapper = "SkillsOverviewCardLeft-module--wrapper--e2e0c";